/* Masque les colonnes vides d'un tableau comparatif.
   Le tableau n'existe que sur certains gabarits : sans garde, la fonction
   levait une TypeError sur toutes les autres pages du site. */
function hideEmptyColumns(tableId) {
  const table = document.getElementById(tableId);
  if (!table) return;                 // page sans tableau comparatif

  const rows = table.rows;
  if (rows.length === 0) return;

  const colCount = rows[0].cells.length;
  const colsToHide = new Set();

  for (let col = 0; col < colCount; col++) {
    let isEmpty = true;

    for (let row = 1; row < rows.length; row++) {
      const cell = rows[row].cells[col];
      if (cell && cell.textContent.trim() !== '') {
        isEmpty = false;
        break;
      }
    }

    if (isEmpty) colsToHide.add(col);
  }

  colsToHide.forEach(col => {
    for (let row = 0; row < rows.length; row++) {
      const cell = rows[row].cells[col];
      if (cell) cell.classList.add('hidden');   // lignes plus courtes tolérées
    }
  });
}

document.addEventListener('DOMContentLoaded', () => hideEmptyColumns('myTable'));
